<script>
	import Select from 'svelte-select';
	import { notifications } from '../notification/notifications';
	import { fetchConfigHistory } from '../../api';
	import { createEventDispatcher } from 'svelte';
	export let type = 'frontend';
	export let id = 'staging';

	let runFetchConfigHistory;

	const dispatch = createEventDispatcher();
	const optionIdentifier = 'name';
	const labelIdentifier = 'name';
	const selectConfigVersion = (e) => {
		notifications.warning(`Loaded  ${e.detail.name} config from history!`, 2000);
		dispatch('selectHistory', e.detail.name);
	};
	$: if (type) {
		runFetchConfigHistory = fetchConfigHistory(type, id);
	}
</script>

{#await runFetchConfigHistory then value}
	<div>
		<Select
			items={value.reverse()}
			{labelIdentifier}
			{optionIdentifier}
			on:select={selectConfigVersion}
			placeholder={'View History'}
		/>
	</div>
{/await}

<style>
	div {
		margin-bottom: 1em;
	}
</style>
